import React, { useMemo } from 'react';
import {
  Checkbox,
  FormControlLabel,
  Typography,
  makeStyles
} from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.text.secondary
  }
}));

export const ShowExpenseReceiptsOnInvoiceCheckBox = ({
  showExpenseReceiptsLabel,
  showExpenseReceipts,
  onShowExpenseReceiptsOnInvoiceChange,
  isReadOnly,
  dataQeId,
  labelClassName,
  variant
}) => {
  const classes = useStyles();
  const titleField = resourceId => {
    return (
      <Typography
        variant={variant || 'caption'}
        className={classnames(classes.title, labelClassName)}
      >
        <FormattedMessage id={resourceId} />
      </Typography>
    );
  };
  const showExpenseReceiptsCheckbox = useMemo(
    () => (
      <Checkbox
        checked={Boolean(showExpenseReceipts)}
        name="showExpenseReceiptsOnTheInvoice"
        onChange={onShowExpenseReceiptsOnInvoiceChange}
        color="primary"
        disabled={isReadOnly}
        size="small"
        data-qe-id={dataQeId && `${dataQeId}_Checkbox`}
        value={Boolean(showExpenseReceipts)}
      />
    ),
    [
      dataQeId,
      isReadOnly,
      onShowExpenseReceiptsOnInvoiceChange,
      showExpenseReceipts
    ]
  );

  return (
    <FormControlLabel
      control={showExpenseReceiptsCheckbox}
      label={titleField(showExpenseReceiptsLabel)}
    />
  );
};

ShowExpenseReceiptsOnInvoiceCheckBox.propTypes = {
  showExpenseReceiptsLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  showExpenseReceipts: PropTypes.bool,
  onShowExpenseReceiptsOnInvoiceChange: PropTypes.func,
  isReadOnly: PropTypes.bool,
  dataQeId: PropTypes.string,
  labelClassName: PropTypes.string,
  variant: PropTypes.string
};

export default ShowExpenseReceiptsOnInvoiceCheckBox;
